import React from "react";
import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-quill/dist/quill.snow.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "react-dropzone-uploader/dist/styles.css";
import "animate.css";
import "react-phone-number-input/style.css";
import { Provider } from "react-redux";
import "moment/locale/fr";
import "react-phone-input-2/lib/style.css";
import store from "./redux/store";
import { fr } from "yup-locales";
import { setLocale } from "yup";
import * as Sentry from "@sentry/react";
setLocale(fr);

if (process.env.NODE_ENV === "production") {

Sentry.init({
  dsn: "https://9a0e0a4d3ad3db2fb1383647ca1c3ac0@o4509598342578176.ingest.de.sentry.io/4510838149218384",
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [Sentry.replayIntegration()],
});
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
